module.exports = __webpack_public_path__ + "static/media/logo-mahou-san-miguel.c2cbd58c.svg";